export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-torsos-all-female-a2fa0bf5e055dc152df62a86644e94f5.svg";